import React, { useRef, useEffect } from 'react';

const keypads = [
  [ 7 ],
  [ 8 ],
  [ 9 ],
  [ 4 ],
  [ 5 ],
  [ 6 ],
  [ 1 ],
  [ 2 ],
  [ 3 ],
  [ <i className='fas fa-backspace'></i>, 'backspace', 'danger' ],
  [ 0 ],
  [ <i className='fas fa-arrow-right'></i>, 'submit', 'success' ]
];

const Keypad = ({ text, click, submit, loading }) => {
  const input = useRef();

  useEffect(() => {
    input.current.focus();
  }, []);

  useEffect(() => {
    // input.current.value = text;
    input.current.focus();
  }, [ text ]);

  const onClickHandler = value => {
    if (!value[ 1 ]) {
      click(prevState => `${ prevState }${ value[ 0 ] }`);
    } else if (value[ 1 ] === 'backspace') {
      click(prevState => prevState.slice(0, -1));
    } else if (value[ 1 ] === 'submit') {
      submit();
    }
  };

  return (
    <>
      <div className='row py-2 mt--4 rounded bg-white'>
        <div className='col-3'>
          <h2>ID PASIEN</h2>
        </div>
        <div className='col-9'>
          <input
            ref={ input }
            onChange={ (e) => click(e.target.value) }
            className='form-control'
            style={ { fontSize: '25px', color: '#2dce8a', border: 0 } }
            value={text}
            />
        </div>
      </div>
      <div className='row mt-3 py-2 rounded bg-white'>
        {keypads.map((keypad, i) => {
          return (
            <div key={ i } className='col-4 py-2'>
              <button
                onClick={ () => onClickHandler(keypad) }
                disabled={ loading }
                type='button'
                className={ `btn btn-${
                  keypad[ 2 ] ? keypad[ 2 ] : 'primary'
                } btn-icon btn-block btn-lg` }>
                <span className={ `btn-inner--${ keypad[ 1 ] ? 'icon' : 'text' }` }>
                  <h2 className='text-white'>{keypad[ 0 ]}</h2>
                </span>
              </button>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default Keypad;
